import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { resetSelected, SelectedResource, setSelected } from "ducks/catalog/catalog";
import { getSelected } from "ducks/catalog/selectors";

export const useSelectedResources = (): [SelectedResource[], VoidFunction, (selected: SelectedResource[]) => void] => {
  const selected = useSelector(getSelected);
  const dispatch = useDispatch();
  const reset = useCallback(() => dispatch(resetSelected()), [dispatch]);

  const toggleSelected = useCallback(
    resources => {
      dispatch(setSelected({ resources }));
    },
    [dispatch],
  );

  return [selected, reset, toggleSelected];
};
